export const stdColorLight = "grey-lighten-1";
export const stdColorDark = "grey-darken-1";
//export const colorSystemBarOn = "#e30613";
export const colorSystemBarOn = "green-lighten-1";
export const colorSystemBarOff = "#ffffff";

export default class MyColors {
  static get stdColorLight() {
    return stdColorLight;
	}

  static get stdColorDark() {
    return stdColorDark;
	}
	
  static get colorSystemBarOn() {
    return colorSystemBarOn;
	}
	
  static get colorSystemBarOff() {
    return colorSystemBarOff;
  }
}
